module.exports = __webpack_public_path__ + "static/media/insert_emoticon.e5564418.svg";